import type { ReactNode } from "react";

import { cn } from "../../utils/cn";

type SectionCardProps = {
  title?: string;
  description?: string;
  children: ReactNode;
  padding?: "sm" | "md" | "lg";
  className?: string;
};

const paddingMap = {
  sm: "p-4",
  md: "p-5",
  lg: "p-6",
};

export function SectionCard({
  title,
  description,
  children,
  padding = "lg",
  className,
}: SectionCardProps) {
  return (
    <div
      data-testid="section-card"
      className={cn(
        "rounded-2xl bg-surface shadow-shell-sm",
        paddingMap[padding],
        className,
      )}
    >
      {title && (
        <div className={cn(description ? "mb-4" : "mb-4")}>
          <h3 className="text-base font-semibold text-text-primary">{title}</h3>
          {description && (
            <p className="mt-1 text-base text-text-secondary">{description}</p>
          )}
        </div>
      )}
      {children}
    </div>
  );
}
